<template>
  <div class="examContainer">
    <div class="selectSide">
      <h2 class="title">课后练习</h2>
      <div class="jumpContainer">
        <div
          :class="[
            'jumpBtn',
            completeList.includes(String(item.id)) ? 'complete' : '',
          ]"
          v-for="(item, index) in examData.dtoList"
          :key="'jumpBtn' + item.id"
          @click="qstIndex = index"
        >
          {{ index + 1 }}
        </div>
      </div>
      <div class="actBar">
        <el-button
          type="primary"
          plain
          :disabled="qstIndex == 0"
          @click="qstIndex--"
          >上一题</el-button
        >
        <el-button type="warning" @click="submit">交卷</el-button>
        <el-button
          type="primary"
          :disabled="qstIndex >= examData.dtoList.length - 1"
          @click="qstIndex++"
          >下一题</el-button
        >
      </div>
    </div>
    <div class="questionSide">
      <div
        class="questionTitle"
        v-html="
          `<div style='display:flex'><div>${qstIndex + 1}[${
            examData.dtoList[qstIndex].type
          }]、</div>` +
          examData.dtoList[qstIndex].content +
          '</div>'
        "
      ></div>
      <div class="selectContainer">
        <div
          :class="[
            'selectCell',
            examData.dtoList[qstIndex].studentChooseList.includes(
              String(select.id)
            )
              ? 'chosen'
              : '',
          ]"
          v-html="
            `<div style='display:flex'><div>${
              englishMap[select.showNo - 1]
            }、</div>` +
            select.content +
            '</div>'
          "
          v-for="select in examData.dtoList[qstIndex].answerDTOList"
          :key="'select' + select.id"
          @click="answerClick(select)"
        ></div>
      </div>
    </div>
    <el-dialog
      title="课后练习结果"
      :visible.sync="consultData.ifShow"
      v-if="consultData.ifShow"
      :append-to-body="true"
    >
      <div class="consultContainer">
        <div class="detailBar">
          <div class="detailCell">
            <div class="detailTitle">得分/总分</div>
            <div class="detailValue">
              {{ consultData.studentScore }}/{{ consultData.totalScore }}
            </div>
          </div>
          <div class="detailCell" style="flex: 2">
            <div class="detailTitle">交卷时间</div>
            <div class="detailValue">
              {{ consultData.endTime }}
            </div>
          </div>
          <div class="detailCell">
            <div class="detailTitle">用时</div>
            <div class="detailValue">
              {{ consultData.consumeTime }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="$emit('eventUp', { type: 'complete' })">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { submitAnswer } from "../../http";
import { getStore } from "../../storage";
export default {
  props: {
    examData: Object,
    examId: Number,
  },
  data() {
    return {
      qstIndex: 0,
      englishMap: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      completeList: [],
      consultData: { ifShow: false },
    };
  },
  computed: {
    userInfo() {
      return JSON.parse(getStore("userInfo"));
    },
  },
  created() {},
  mounted() {},
  methods: {
    answerClick(asw) {
      let theQuestion = this.examData.dtoList[this.qstIndex];
      if (theQuestion.questionTypeId == 1 || theQuestion.questionTypeId == 5) {
        theQuestion.studentChooseList = [String(asw.id)];
      } else {
        if (theQuestion.studentChooseList.includes(String(asw.id))) {
          theQuestion.studentChooseList.splice(
            theQuestion.studentChooseList.indexOf(String(asw.id)),
            1
          );
        } else {
          theQuestion.studentChooseList.push(String(asw.id));
        }
      }
      this.completeList = this.examData.dtoList
        .filter((item) => item.studentChooseList.length > 0)
        .map((item) => String(item.id));
    },
    submit() {
      console.log(this.examData.dtoList);
      submitAnswer({
        examId: this.examId,
        idCard: this.userInfo.idCard,
        dtoList: this.examData.dtoList,
        startTime: this.examData.startTime,
        recordId: this.examData.recordId,
      }).then((data) => {
        this.consultData = data;
        this.consultData.ifShow = true;
      });
    },
  },
};
</script>

<style scoped lang="less">
.examContainer {
  display: flex;
  .selectSide {
    width: 300px;
    .title {
    }
    .jumpContainer {
      border: 1px solid #ccc;
      height: 50vh;
      overflow-y: scroll;
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0;
      .jumpBtn {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #618afd;
        border-radius: 50%;
        margin: 8px;
        font-size: 24px;
        cursor: pointer;
      }
      .complete {
        color: #fff;
        background: #618afd;
      }
    }
    .actBar {
      display: flex;
      justify-content: space-between;
    }
  }
  .questionSide {
    flex: 1;
    margin-left: 30px;
    height: 80vh;
    overflow-y: scroll;
    font-size: 24px;
    .questionTitle {
      margin: 10px 0;
    }
    .selectContainer {
      .selectCell {
        margin: 15px 0;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 10px;
        cursor: pointer;
      }
      .chosen {
        border: 1px solid #618afd !important;
      }
    }
  }
}
.consultContainer {
  .detailBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .detailCell {
      text-align: center;
      flex: 1;
      .detailTitle {
        font-size: 28px;
      }
      .detailValue {
        font-size: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buy/courseExam.vue